export default "__VITE_ASSET__Dc0nhS7o__"